export default {
  textOrder: 'Weet je zeker dat je dit wilt bestellen?',
  textRating: 'Hoe beoordeel je jou advies?',
  notWorking: 'Deze knop doet nog niks',
};
